import React from "react"
import PropTypes from "prop-types"
import ReactSelect from "react-select"
import { StyledDiv } from "./styles"

const SearchSelect = ({ handleInputChange, options, simpleForm, searchOptions, invalid, value, ...rest }) => {
  const onChange = (selectedOption) => {
    handleInputChange(rest.name, selectedOption.value)
  }

  return (
    <StyledDiv simpleForm={simpleForm} invalid={invalid}>
      <ReactSelect
        options={searchOptions}
        onChange={onChange}
        classNamePrefix="react-select"
        value={searchOptions.find((option) => option.value === value || option.label === value) || null}
      />
    </StyledDiv>
  )
}

SearchSelect.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  simpleForm: PropTypes.bool,
  invalid: PropTypes.bool
}

export default SearchSelect
